var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconJustificar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.9998V16.9539H18V18.9998H9H0ZM1.845 14.5689V11.5764L10.2375 3.18389L13.23 6.17639L4.8375 14.5689H1.845ZM3.195 13.2189H4.2075L11.295 6.13139L10.2825 5.11889L3.195 12.2064V13.2189ZM14.22 5.18639L11.2275 2.19389L13.1175 0.303894C13.2825 0.108894 13.47 0.00764379 13.68 0.00014379C13.89 -0.00735621 14.1 0.0938938 14.31 0.303894L16.065 2.05889C16.26 2.25389 16.3575 2.46014 16.3575 2.67764C16.3575 2.89514 16.275 3.10139 16.11 3.29639L14.22 5.18639Z",
    fill: "#263668"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconJustificar);
export default __webpack_public_path__ + "static/media/iconJustificar.81fc14cdd18a1887d2f9ee6f85457b63.svg";
export { ForwardRef as ReactComponent };